import { appEnvironment } from "./app.environment";

export const environment = {
  production: false,
  environment: 'dev',
  tmnBackApi: 'https://apiv2-nprd.cloud.bpifrance.fr/dev/nof/trackmanotif/api',
  campaigns: {
    minHourScheduleCampaign: 8,
    maxHourScheduleCampaign: 19,
  },
  sso: {
    enabled: true,
    issuer: 'https://authmfamoa.web.bpifrance.fr',
    clientId: 'HmtHAV8Ssv7fTT5ViY2O',
    discoveryDocumentEndpoint: 'mga/sps/oauth/oauth20/metadata/OIDCP_All-Prof_MFA',
    tokenType: 'access_token'
  },
  tcContainerUrl: 'https://cdn.tagcommander.com/7805/uat/tc_TrackMaNotif_20.js', // EasyTrack: HorsPROD container URL
  appEnvironment
};